<script lang="ts">
	import SubscriptionSetupStep from "@components/SubscriptionSetupStep.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import type { ClassValue } from "svelte/elements";

	interface HowItWorksStep {
		title: string;
		description: string;
		class: ClassValue;
		textClass?: ClassValue;
	}

	const {
		id,
		section,
		title,
		steps,
		checks,
		footer,
	}: {
		id?: string;
		section: string;
		title: string;
		steps: HowItWorksStep[];
		checks?: string[];
		footer?: string;
	} = $props();
</script>

<section class="py-11 full-width grid-container bg-fcrbeige [counter-reset:how-it-works]" {id}>
	<div class="mb-9 text-center uppercase text-fcrorange container-6 font-bold tracking-[.1em]">
		<Formatted text={section} />
	</div>
	<Heading
		level={2}
		text={title}
		class={["font-antipol font-medium text-8/tighter text-fcrdarkgray mb-4", "mx-auto text-center max-w-150"]}
	/>
	{#each steps as step (step.title)}
		<SubscriptionSetupStep
			title={step.title}
			description={step.description}
			class={step.class}
			textClass={step.textClass}
		/>
	{/each}
	{#if checks?.length}
		<ul class="mt-2 container-6 text-center text-fcrgray text-sm/relaxed space-y-1">
			{#each checks as check (check)}
				<li><Formatted text={check} /></li>
			{/each}
		</ul>
	{/if}
	{#if footer}
		<p class="mt-4 text-fcrgray text-center [font-feature-settings:'cv11'_1,'cv13'_1] container-6">
			<Formatted text={footer} />
		</p>
	{/if}
</section>
